import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/target-heart-rate-calculator',
  component: () => import('../../routes/TargetHeartRateCalculator.svelte'),
  card: {
    id: 'target-heart-rate',
    title: 'Target Heart Rate',
    description:
      'Calculate your optimal heart rate zones for exercise using the Karvonen formula or simple percentage-of-max method.',
    icon: 'favorite',
    iconBgClass: 'bg-red-50',
    iconTextClass: 'text-red-600',
    href: '/target-heart-rate-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Target Heart Rate Calculator – Karvonen Formula & Training Zones',
    description:
      'Free target heart rate calculator to find your optimal exercise intensity zones using the Karvonen (Heart Rate Reserve) method or simple % of max. Includes all 5 training zones.',
  },
};

export default meta;
